import React from 'react'

import { FaTimes } from "react-icons/fa";
export default function Alert({alert, setAlert}) {
  if(alert.length < 1) return null
 
  return (
    <div className={`alert center ${alert.type}`}>
        <div className="close center" onClick={()=>setAlert([])}><FaTimes /></div>
        <p>{alert.ms}</p>
    </div>
    
  )
}
